import { useState } from 'react';

import type { FormattedDateString } from '../types/FormattedDateString';

type HookResult = {
  isHovered: (day: FormattedDateString) => boolean;
  toggleHover: (day: FormattedDateString) => void;
};
const useHoverColumns = (columns: Array<FormattedDateString>): HookResult => {
  const DEFAULT_HOVER_MAP = columns.reduce((result, day) => {
    result[day] = false;
    return result;
  }, {});
  const [hoveredDays, setHoveredDays] = useState({ ...DEFAULT_HOVER_MAP });

  const toggleHover = (day: FormattedDateString): void => {
    setHoveredDays({
      ...DEFAULT_HOVER_MAP,
      [day]: !hoveredDays[day],
    });
  };

  const isHovered = (day: FormattedDateString): boolean => {
    return Boolean(hoveredDays[day]);
  };

  return {
    isHovered,
    toggleHover,
  };
};

export default useHoverColumns;
